// extracted by mini-css-extract-plugin
export default {"input-code":"CodeInput_input-code__cZXkc","input-code_error":"CodeInput_input-code_error__jv9H9"};